import SectorQueue from './SectorQueue'

function ExternalFaction() {
    return <SectorQueue sector="Facção Externa" />
}

export default ExternalFaction
